import React, { Fragment, Component } from "react";
import "./styles/base.css";
import { Cart, Tag } from "./types";
import ajax from "superagent";
import _ from "lodash";
import { Photo } from "../MasterImageSearch/components/types";
import PhotoGallery from "./PhotoGallery";
import { Filters } from ".";
import { withCartIdParam } from "../../utils/BrowserHelper";
import { PageConfigurationContextConsumer } from "./index";

interface PhotosContainerProps {
  cart: Cart;
  filters: Filters;
  photosAPI: string;
  addToCartAPI: string;
  currentUserId: number;
  organizationId: number;
  organizationName: string;
  isEventOrganizer: boolean;
  removeFromCartAPI: string;
  embedMode: boolean;
  isAuthorizedForDirectDownloads: boolean;
  secureAccessToken: string | null;
  removeTag: Function;
  tagsValue: string | null;
  canManageTags: boolean;
  securedOrgView: boolean;
  registerGuestUserAPI: string;
  setGuestUserId: (userId: number) => void;
  directDownloadEnabled: boolean;
}

interface PhotosContainerState {
  cart: Cart;
  photos: Photo[];
  nextPage: number;
  totalCount: number;
  tagsApplied: boolean;
  imageUploaded: boolean;
  albumGrouping: boolean;
  loadingPhotos: boolean;
  eventNameFilter: string;
  locationFilter: string;
}

class PhotosContainer extends Component<
  PhotosContainerProps,
  PhotosContainerState
> {
  constructor(props: PhotosContainerProps) {
    super(props);
    this.state = {
      photos: [],
      nextPage: 0,
      totalCount: 0,
      cart: props.cart,
      albumGrouping: false,
      loadingPhotos: false,
      imageUploaded: !!props.filters.referenceImage,
      tagsApplied: props.filters.tags.length !== 0,
      eventNameFilter: props.filters.eventName,
      locationFilter: props.filters.location
    };
  }

  public componentDidMount() {
    this.loadPhotos(this.props.filters, true);
  }

  public componentWillReceiveProps(nextProps: PhotosContainerProps) {
    if (
      !_.isEqual(
        this.props.filters.referenceImage,
        nextProps.filters.referenceImage
      )
    ) {
      this.loadPhotos(nextProps.filters, true);
    }
    if (this.props.filters.eventName !== nextProps.filters.eventName) {
      this.setState({ eventNameFilter: nextProps.filters.eventName });
    }
    if (this.props.filters.location !== nextProps.filters.location) {
      this.setState({ locationFilter: nextProps.filters.location });
    }
    if (
      this.props.canManageTags &&
      this.props.tagsValue !== nextProps.tagsValue
    ) {
      this.loadPhotos(nextProps.filters, true);
    }
  }

  public render() {
    return (
      <PageConfigurationContextConsumer>
        {context =>
          context &&
          (this.state.imageUploaded || this.state.tagsApplied) && (
            <Fragment>
              {!this.state.loadingPhotos && (
                <div className="container">
                  <div className="orgevents-search-count geo-form album-grouping-btn">
                    <b>{this.displayResultText()}</b>
                    {!this.state.tagsApplied && (
                      <label
                        htmlFor="album-grouping"
                        className="check-radio geo-form__label geo-form--check"
                      >
                        <input
                          id="album-grouping"
                          type="checkbox"
                          className="geo-form__checkbox"
                          checked={this.state.albumGrouping}
                          onChange={() =>
                            this.setState({
                              albumGrouping: !this.state.albumGrouping
                            })
                          }
                        />
                        <span
                          className="r-dot"
                          style={{
                            backgroundColor: this.state.albumGrouping
                              ? context.primaryColor || "#259fa5"
                              : "#e4e4e4"
                          }}
                        ></span>
                        <span className="r-desc">Group photos by albums</span>
                      </label>
                    )}
                  </div>
                </div>
              )}
              <PhotoGallery
                loadingPhotos={this.state.loadingPhotos}
                photos={this.filteredPhotos()}
                albumGrouping={this.state.albumGrouping}
                cart={this.state.cart}
                addPhotoToCart={this.addPhotoToCart}
                removePhotoFromCart={this.removePhotoFromCart}
                loadMorePhotos={() => {
                  if (this.hasMorePhotos()) this.loadPhotos(this.props.filters);
                }}
                embedMode={this.props.embedMode}
                hasMorePhotos={this.hasMorePhotos()}
                isAuthorizedForDirectDownloads={
                  this.props.isAuthorizedForDirectDownloads
                }
                primaryColor={context.primaryColor}
                userId={this.props.currentUserId}
                filters={this.props.filters}
                organizationId={this.props.organizationId}
                albumFilter={false}
                securedOrgView={this.props.securedOrgView}
                registerGuestUserAPI={this.props.registerGuestUserAPI}
                setGuestUserId={this.props.setGuestUserId}
                secureAccessToken={this.props.secureAccessToken}
                directDownloadEnabled={this.props.directDownloadEnabled}
              />
            </Fragment>
          )
        }
      </PageConfigurationContextConsumer>
    );
  }
  private hasMorePhotos = () => !!this.state.nextPage;

  private loadPhotos = (
    filters: Filters | null,
    reset: boolean | null = false
  ) => {
    if (reset) this.setState({ loadingPhotos: true, photos: [] });

    this.photosRequest(
      this.props.photosAPI,
      filters,
      reset ? 1 : this.state.nextPage
    )
      .then(response => {
        this.setState({
          photos: _.filter(
            _.concat(this.state.photos, response.body.photos),
            photo => !!photo.watermarkedImg
          ),
          nextPage: response.body.meta.nextPage,
          totalCount: response.body.meta.totalCount,
          loadingPhotos: false
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  private filteredPhotos = () => {
    if (this.state.eventNameFilter !== "" && this.state.locationFilter !== "") {
      let photosFiltered = this.state.photos.filter((photo: Photo) =>
        photo.album.event.name
          .toLowerCase()
          .includes(this.state.eventNameFilter.toLowerCase())
      );
      photosFiltered = photosFiltered.filter((photo: Photo) =>
        photo.album.event.location
          .toLowerCase()
          .includes(this.state.locationFilter.toLowerCase())
      );
      return photosFiltered;
    } else if (this.state.eventNameFilter !== "")
      return this.state.photos.filter((photo: Photo) =>
        photo.album.event.name
          .toLowerCase()
          .includes(this.state.eventNameFilter.toLowerCase())
      );
    else if (this.state.locationFilter !== "")
      return this.state.photos.filter((photo: Photo) =>
        photo.album.event.location
          .toLowerCase()
          .includes(this.state.locationFilter.toLowerCase())
      );
    return this.state.photos;
  };

  private photosRequest = (
    url: string,
    filters: Filters | null,
    pageNumber: number
  ) => {
    let req = ajax.get(url).query({
      page: pageNumber,
      user_id: this.context.currentUserId
    });

    if (filters && !!filters.referenceImage) {
      req = req.query({
        reference_image: filters.referenceImage
      });
    }

    if (filters && !!filters.tags) {
      req = req.query({
        "tag_id[]": filters.tags.map(tag => tag.id)
      });
    }

    if (this.props.isEventOrganizer) {
      req = req.query({ organizer_id: this.props.organizationId });
    } else {
      req = req.query({
        photographer_events_filter: true,
        slug: this.props.organizationName
      });
    }

    if (this.props.secureAccessToken) {
      req = req.query({
        secure_access_token: this.props.secureAccessToken
      });
    }

    return req;
  };

  private addPhotoToCart = (photo: Photo) => {
    if (
      this.state.cart &&
      photo.album.event.currency !== this.state.cart.currency &&
      this.state.cart.photos.length > 0
    ) {
      // @ts-ignore
      toastr.error(
        `The cart can only contain photos in one currency, currently ${photo.album.event.currency}. Clear and try adding again.`
      );
    } else {
      this.setState({
        cart: {
          ...this.state.cart,
          photos: _.concat(
            this.state.cart ? this.state.cart.photos : [],
            photo.id
          ),
          currency: photo.album.event.currency
        }
      });

      // @ts-ignore
      (window.dataLayer || []).push({ event: "addToCart" });

      ajax
        .post(this.props.addToCartAPI)
        .send({
          photo_id: photo.id,
          cart_id: this.state.cart ? this.state.cart.id : null
        })
        .then(res => {
          this.setState(
            {
              cart: res.body.cart
            },
            () => {
              $.getScript(
                withCartIdParam("/cart_sales_count", this.state.cart.id)
              );
              // @ts-ignore
              toastr.success("Added to cart", null, { timeOut: 1000 });
            }
          );
        })
        .catch(err => console.log(err, "error"));
    }
  };

  private removePhotoFromCart = (photo: Photo) => {
    this.setState({
      cart: {
        ...this.state.cart,
        photos: _.without(this.state.cart.photos, photo.id)
      }
    });

    ajax
      .delete(this.props.removeFromCartAPI)
      .send({ photo_id: photo.id, cart_id: this.state.cart.id })
      .then(() => {
        $.getScript(withCartIdParam("/cart_sales_count", this.state.cart.id));
        // @ts-ignore
        toastr.success("Removed from cart", null, {
          timeOut: 1000
        });
      })
      .catch(err => console.log(err));
  };

  private displayResultText = () => {
    if (this.state.imageUploaded) {
      return `${this.filteredPhotos().length} results match your selfie`;
    } else {
      return (
        <div className="tags-list">
          <span className="results-count">
            {this.filteredPhotos().length} results found for{" "}
          </span>
          {this.props.filters.tags.map((tag: Tag, index: number) => (
            <div key={index} className="tag-edit-span regular-tag">
              <span>{tag.name}</span>
              <span onClick={() => this.props.removeTag(index)}>×</span>
            </div>
          ))}
        </div>
      );
    }
  };
}

export default PhotosContainer;
